import { DateHelpers } from '@crm/shared/lib';

import type { TFormInput } from './form.schema';

export const defaultFormValues: TFormInput = {
    dealName: '',
    customerName: '',
    phone: '',
    source: '',
    budget: '',
    objectType: '',
    areaSquare: '',
    receivedAt: DateHelpers.formatDisplayDate(new Date()),
    description: '',
};
